import React from 'react';
import { hasPermission } from '../../utils/permissions';

/**
 * Reusable TabNavigation component for consistent tabs across the application
 * 
 * @param {Object[]} tabs - Array of tab objects with id, label, icon, permission info
 * @param {string} activeTab - ID of the currently active tab
 * @param {function} onTabChange - Function to call when tab is changed
 * @returns {JSX.Element} - The rendered TabNavigation component
 */
const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="mb-6 border-b border-gray-200">
      <ul className="flex flex-wrap -mb-px">
        {tabs.map((tab) => {
          // Only render tab if user has permission or no permission required
          const showTab = !tab.permission || 
            (tab.permission && hasPermission(tab.permission.section, tab.permission.action));
            
          return showTab && (
            <li key={tab.id} className="mr-2">
              <button
                onClick={() => onTabChange(tab.id)}
                className={`inline-block py-3 px-4 text-sm font-medium ${
                  activeTab === tab.id
                    ? 'text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-500 hover:text-gray-700 border-b-2 border-transparent hover:border-gray-300'
                }`}
                aria-current={activeTab === tab.id ? 'page' : undefined}
              >
                <div className="flex items-center">
                  {tab.icon}
                  {tab.label}
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TabNavigation;